var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGlass(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 127,
    height: 127,
    viewBox: "0 0 127 127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5882",
    "data-name": "Grupo 5882",
    transform: "translate(-1.825 -1.725)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5279",
    "data-name": "Trazado 5279",
    d: "M125.67,104.535,98.114,76.979a11.243,11.243,0,0,0-14.935-.631L72.451,65.619A39.589,39.589,0,1,0,41.319,80.765a39.055,39.055,0,0,0,24.4-8.414L76.447,83.079a10.807,10.807,0,0,0,.631,14.935l27.556,27.556a11.177,11.177,0,0,0,15.566,0l5.469-5.469a11.176,11.176,0,0,0,0-15.566M19.863,62.675a30.12,30.12,0,1,1,42.491,0,30.216,30.216,0,0,1-42.491,0m99.076,50.905-5.469,5.469a1.651,1.651,0,0,1-2.314,0L83.6,91.493a1.651,1.651,0,0,1,0-2.314l5.469-5.469a1.525,1.525,0,0,1,2.1,0l27.556,27.556a1.5,1.5,0,0,1,.21,2.314",
    transform: "translate(0 0)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5280",
    "data-name": "Trazado 5280",
    d: "M18.138,24.276H28.445a4.893,4.893,0,0,0,4.838-4.838A4.76,4.76,0,0,0,28.445,14.6H18.138A4.893,4.893,0,0,0,13.3,19.438a4.76,4.76,0,0,0,4.838,4.838m21.456,6.1H18.138A4.893,4.893,0,0,0,13.3,35.215a4.76,4.76,0,0,0,4.838,4.838H39.594a4.838,4.838,0,1,0,0-9.676",
    transform: "translate(12.663 14.208)",
    fill: "#999"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlass);
export default __webpack_public_path__ + "static/media/glass.f657e7ef6f25bf74aba3354d7cf3736b.svg";
export { ForwardRef as ReactComponent };